export default "__VITE_ASSET__5a681777__"